RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.InfluencerPopover = RivalIQ.views.LayoutView.mixin({
        template: '#discoveryInfluencerPopoverTemplate',

        className: 'influencer-popover',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            noOverviewText: '.x-influencer-no-overview',
            followingMetric: '.x-following',
            influencerScoreContainer: '.x-influencer-score-container',
            influencerScore: '.influencer-score'
        },

        loadData: function () {
            const me = this;

            if (me.model) {
                const deferred = new $.Deferred();
                deferred.resolve();
                return deferred;
            }

            return RivalIQ.apps.Discovery.data.influencers.fetch({
                channel: me.getProp('channel'),
                handle: me.getOption('influencerHandle')
            })
                .then(function (user) {
                    me.model = new Backbone.Model(user);
                });
        },

        onLoadDataError: function (error) {
            const me = this;

            if (error) {

                if (_.get(error, 'errorName') === 'UnknownHandleError') {
                    const handle = me.getOption('influencerHandle');
                    const channel = me.getOption('dashboardModel').getProp('channel');

                    me.loadingView.$el.css('height', 'auto');
                    me.loadingView.$el.addClass('widget-error');
                    me.loadingView.$el.html(Marionette.TemplateCache.get('#nonBusinessPresenceErrorView')(_.extend({
                        handle: handle
                    }, App.utils.generateProfileLinks(handle, channel))));
                    me.$el.addClass('not-analyzable');
                } else {

                    let errorTemplate = '#widgetErrorView';
                    if (_.get(error, 'errorName') === 'NotAuthorizedError') {
                        errorTemplate = '#privatePresenceErrorView';
                    }

                    me.loadingView.showError('widget-error', errorTemplate);
                }
            }
        },

        onRender: function () {
            const me = this;

            if (_.trim(me.model.get('overview')).length === 0) {
                me.ui.noOverviewText.show();
            }

            me.showInfluencerScore();
        },

        showInfluencerScore: function () {
            const me = this;

            const influencerScore = me.model.get('influencer_score');
            if (_.isFinite(influencerScore)) {
                me.ui.followingMetric.hide();

                new App.views.InfluencerScoreTableCell({
                    data: [influencerScore],
                    el: me.ui.influencerScore
                }).render();
                me.ui.influencerScoreContainer.show();
            } else {
                const channel = me.getOption('dashboardModel').getProp('channel');
                if (channel === RivalIQ.enums.channels.INSTAGRAM) {
                    me.ui.followingMetric.hide();
                } else {
                    me.ui.followingMetric.show();
                }

                me.ui.influencerScoreContainer.hide();
            }
        },

        serializeData: function () {
            const me = this;
            const user = me.model.toJSON();
            const dashboardModel = me.getOption('dashboardModel');
            const channel = dashboardModel.getProp('channel');
            const postWord = RivalIQ.data.channels.get(channel).get('postName');
            const filterLink = App.utils.getFilterUrl('postAuthor', user.handle, dashboardModel);
            const analyzeAccountUrl = App.utils.getAnalyzeAccountUrl(dashboardModel, user.handle);
            const showActions = me.getOption('showActions');

            const reachFormatted = RivalIQ.formatter.formatAbbreviated(user.presence_reach);
            const followingFormatted = RivalIQ.formatter.formatAbbreviated(user.presence_following);

            return _.extend({
                following: false,
                verified: null,
                postWord: postWord,
                filterLink: filterLink,
                followingFormatted: followingFormatted,
                reachFormatted: reachFormatted,
                analyzeAccountUrl: analyzeAccountUrl,
                showActions: showActions,
                icon_url: null
            }, App.utils.generateProfileLinks(user.handle, channel), user);
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        }
    });

    views.InfluencerPopover.addPopovers = function (table, influencerEls, influencers, showActions) {
        let popoverShowTimeout;
        _.each(influencerEls, function (influencerEl) {
            const postAuthor = $(influencerEl);
            postAuthor.popover({
                trigger: 'manual',
                html: true,
                placement: 'auto',
                container: table.$el,
                content: function () {
                    const influencerHandle = $(this).data('influencer-handle');

                    const influencer = _.get(influencers, [influencerHandle]);
                    if (!table._cachedInfluencerPopover || table._influencerPopoverCacheHandle !== influencerHandle) {

                        const viewOptions = {
                            influencerHandle: influencerHandle,
                            dashboardModel: table.dashboardModel,
                            showActions: Boolean(showActions)
                        };

                        // if we have influencer data, we can save a network trip.
                        if (influencer) {
                            viewOptions.model = new Backbone.Model(influencer);
                        }

                        const popover = new App.views.InfluencerPopover(viewOptions);

                        table._cachedInfluencerPopover = popover;
                        popover.render();

                        table._influencerPopoverCacheHandle = influencerHandle;

                        if (popover._deferred.state() === 'pending') {

                            popover.loadingView = new popover.LoadingView({
                                template: popover.loadingViewTemplate
                            });
                            popover.el.appendChild(popover.loadingView.render().el);

                            popover._deferred.then(function () {
                                popover.loadingView.hideForView(popover);
                                postAuthor.popover('show');
                            });
                        }
                    }

                    return table._cachedInfluencerPopover.el;
                }
            })
                .on('mouseenter', function () {
                    const popoverThis = this;

                    clearTimeout(popoverShowTimeout);

                    // This setTimeout is the delay on hover before we show the popover.
                    popoverShowTimeout = setTimeout(function () {
                        if ($(popoverThis).is(':hover')) {
                            $(popoverThis).popover('show');

                            // This is to allow the user to hover over the popover without it closing on them;
                            // instead of listening for a mouseleave event, just periodically check to see if they're
                            // still hovering.
                            const interval = setInterval(function () {
                                if (!$('.popover:hover').length) {
                                    if (!$(popoverThis).is(':hover')) {
                                        $(popoverThis).popover('hide');
                                        clearInterval(interval);
                                    }
                                }
                            }, 400);
                        }
                    }, 400);
                })
                .data('bs.popover').tip().addClass('influencer-popover-container');
        });

        table.$el.on('hidden.bs.popover', function () {
            table._cachedInfluencerPopover = null;
        });
    };
});
